import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import {
  AppBar,
  Badge,
  CssBaseline,
  Divider,
  Drawer,
  Grid,
  Hidden,
  Icon,
  IconButton,
  List,
  Toolbar,
  Tooltip,
  Typography,
  Card,
  Paper,
  Dialog,
  DialogContent,
  DialogActions,
  Link,
  CardContent,
  CardMedia,
  Button
} from '@material-ui/core/';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useLocation, useHistory } from 'react-router-dom';
import Copyright from './Copyright';
import ConfirmarAccion from '../ConfirmarAccion';
import { COD_AVISO_DISENTIMIENTO } from '../../bienestar_estudiantil/helper';
import Cargando from './Cargando';
import AppBarModal from './../AppBarModal';
import { BtnForm } from './../BotonesAccion';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import {
  RutasPrincipales,
  RutasInicio,
  menuPrincipal,
  menuSecundario,
} from './Rutas';
import {
  actualizarAuth,
  actualizarDataUsuarioAuth,
  mostrarModalCerrar,
  actualizarActividades,
  actualizarMensaje,
  mostrarModalMensajes,
  actualizarCargandoMenu,
  mostrarModalNotificaciones,
  mostrarModalRegistrar,
  mostrarModalVideos
} from "../../../redux/actions/actGlobal";
import {
  validarUsuarioApp,
  CerrarApp,
  obtenerActividadesPerfil,
  consulta,
  api,
  mostrarError,
  getFotoMs
} from "../../../global/js/funciones";
import logo_cuc_front from "../../../global/imagenes/logo_cuc_blanco_horizontal.png";
import navbar_fondo_rojo from "../../../global/imagenes/navbar_fondo_rojo.png";
import Perfil from './Perfil';
import Videos from './Videos';


const drawerWidth = 285;
const useStyles = makeStyles(theme => ({
  appBar: {
    backgroundColor: '#C9030E',
    backgroundImage: `url(${navbar_fondo_rojo})`,
    backgroundSize: 'cover',
    backgroundPosition: 'right center',
    backgroundRepeat: 'no-repeat',
    color: '#ffffff',
    transition: theme.transitions.create(['margin', 'width', 'box-shadow'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      transition: theme.transitions.create(['margin', 'width', 'box-shadow'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }
  },
  appBarScrolled: {
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
  },
  avatar: {
    margin: 0,
    width: 30,
    height: 30,
  },
  avatar_text: {
    margin: 0,
    width: 50,
    height: 50,
  },
  content: {
    flexGrow: 1,
    minHeight: '100vh',
    height: 'auto',
    overflow: 'visible',
    display: 'flex',
    flexDirection: 'column',
    transition: theme.transitions.create(['margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.up('sm')]: {
      marginLeft: 0,
    }
  },
  contentShift: {
    [theme.breakpoints.up('sm')]: {
      marginLeft: drawerWidth,
    }
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      flexShrink: 0,
    },
  },
  root: {
    display: 'flex',
  },
  rootCard: {
    maxWidth: 345,
  },
  logo: {
    width: "80%",
  },
  logocuc: {
    marginTop: "5%",
    width: 70,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  topActionLight: {
    color: '#ffffff !important',
  },
  logoVerticalTop: {
    height: 24,
    width: 'auto',
    marginRight: theme.spacing(1),
    objectFit: 'contain',
    [theme.breakpoints.down('xs')]: {
      height: 20,
    },
  },
  title: {
    flexGrow: 50,
    textTransform: "uppercase",
    textAlign: 'center',
    color: '#ffffff !important',
  },
  toolbar: theme.mixins.toolbar,
  drawerHeader: {
    ...theme.mixins.toolbar,
    backgroundColor: '#C9030E',
    backgroundImage: `url(${navbar_fondo_rojo})`,
    backgroundSize: 'cover',
    backgroundPosition: 'right center',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 8,
  },
  drawerPaper: {
    width: drawerWidth,
    '& .MuiListItemText-primary': {
      fontSize: '0.9rem',
    },
    '& .MuiListItemText-secondary': {
      fontSize: '0.78rem',
    },
  },
  linkCard: {
    display: 'block',
    position: 'relative',
    transition: 'box-shadow 0.2s',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    }
  },
  disentimientoLink: {
    display: 'block',
    position: 'relative',
    borderRadius: 12,
  },
  disentimientoCard: {
    border: '1px solid #f1d3d3',
    borderRadius: 12,
    overflow: 'hidden',
    boxShadow: '0 6px 20px rgba(74, 20, 20, 0.08)',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 10px 26px rgba(74, 20, 20, 0.14)',
    },
  },
  disentimientoContent: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(3),
    padding: `${theme.spacing(3)}px !important`,
    [theme.breakpoints.down('xs')]: {
      alignItems: 'stretch',
      flexDirection: 'column',
      gap: theme.spacing(2),
      padding: `${theme.spacing(2)}px !important`,
    },
  },
  disentimientoImagen: {
    width: 180,
    height: 140,
    flexShrink: 0,
    objectFit: 'contain',
    borderRadius: 10,
    backgroundColor: '#fff7f7',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      height: 120,
    },
  },
  disentimientoTexto: {
    flex: 1,
    minWidth: 0,
    textAlign: 'left',
  },
  disentimientoEtiqueta: {
    display: 'inline-block',
    marginBottom: theme.spacing(1),
    color: '#9f1239',
    fontSize: '0.72rem',
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
  },
  disentimientoTitulo: {
    marginBottom: theme.spacing(1),
    color: '#2f1b1b',
    fontWeight: 600,
  },
  disentimientoDescripcion: {
    marginBottom: theme.spacing(2),
    lineHeight: 1.6,
  },
  disentimientoBoton: {
    backgroundColor: '#B70E0C',
    color: '#ffffff',
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#8f0b09',
      boxShadow: 'none',
    },
  },
  notiDialogPaper: {
    '& .MuiAppBar-root': {
      backgroundColor: '#B70E0C',
      borderBottom: 'none',
    },
    '& .MuiAppBar-root .MuiTypography-root': {
      color: '#ffffff',
    },
    '& .MuiAppBar-root .MuiIconButton-root': {
      color: '#ffffff',
    },
  },
  notiPaper: {
    borderRadius: '0 8px 8px 0',
    overflow: 'hidden',
  },
  notiCard: {
    borderTop: '0.5px solid #e5e7eb',
    borderRight: '0.5px solid #e5e7eb',
    borderBottom: '0.5px solid #e5e7eb',
    borderLeft: '8px solid #B70E0C',
    borderRadius: '0 8px 8px 0',
    overflow: 'hidden',
  },
  notiImg: {
    display: 'block',
    width: '100%',
    height: 120,
    objectFit: 'contain',
    background: '#fff',
    borderBottom: '0.5px solid #e5e7eb',
  },
  notiBody: {
    padding: theme.spacing(3, 3.5),
    textAlign: 'left',
  },
  notiTag: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 7,
    marginBottom: 16,
    padding: '6px 14px',
    borderRadius: 999,
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: 0.3,
    color: '#B70E0C',
    background: '#fdecec',
  },
  notiTitulo: {
    fontWeight: 700,
    fontSize: '1.6rem',
    lineHeight: 1.25,
    letterSpacing: -0.2,
    color: '#B70E0C',
    marginBottom: 8,
  },
  notiDescripcion: {
    color: '#374151',
    fontSize: '1.1rem',
    lineHeight: 1.7,
    whiteSpace: 'pre-line',
  },
  notiCorreo: {
    color: '#B70E0C',
    fontWeight: 600,
    cursor: 'pointer',
  },
  notiVerMas: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    marginTop: 18,
    fontSize: 15,
    fontWeight: 700,
    color: '#B70E0C',
  }
}));

function Modulo({ modulo, cerrarSesion, modalCerrar, mostrarModalCerrar, usuario, actividades, mensajes, mostrarModalMensajes, mostrarModalNotificaciones, modalNotificaciones, notificationes, guardarConfirmacion, mostrarModalVideos, modalVideos }) {
  const classes = useStyles();
  const theme = useTheme();
  const location = useLocation();
  const history = useHistory();
  const datoBuscar = new URLSearchParams(location.search || '').get('q') || '';
  const isInicio = modulo?.ruta === "/";
  const isEncuesta = location.pathname.startsWith('/encuesta_graduados');
  const isPracticas = location.pathname.startsWith('/practicas') || location.pathname.startsWith('/mis_practicas');
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [desktopOpen, setDesktopOpen] = React.useState(isInicio);
  const [scrolled, setScrolled] = React.useState(false);
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

  React.useEffect(() => {
    const scrollContainer = document.getElementById('seccion-vista');
    const onScroll = () => {
      const containerTop = scrollContainer ? scrollContainer.scrollTop : 0;
      const windowTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      setScrolled(Math.max(containerTop, windowTop) > 6);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', onScroll, { passive: true });
    }
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (scrollContainer) {
        scrollContainer.removeEventListener('scroll', onScroll);
      }
    };
  }, []);

  React.useEffect(() => {
    const cls = 'sidebar-open-desktop';
    if (isDesktop && desktopOpen) {
      document.body.classList.add(cls);
    } else {
      document.body.classList.remove(cls);
    }
    return () => document.body.classList.remove(cls);
  }, [isDesktop, desktopOpen]);

  React.useEffect(() => {
    if (!isDesktop) return;
    setDesktopOpen(isInicio);
  }, [isDesktop, isInicio]);

  React.useEffect(() => {
    if (!isDesktop) return;
    if (isPracticas) setDesktopOpen(false);
  }, [isDesktop, isPracticas]);

  React.useEffect(() => {
    const cls = 'encuesta-view';
    if (isEncuesta) {
      document.body.classList.add(cls);
    } else {
      document.body.classList.remove(cls);
    }
    return () => document.body.classList.remove(cls);
  }, [isEncuesta]);

  function handleDrawerToggle() {
    if (isDesktop) {
      setDesktopOpen((prev) => !prev);
    } else {
      setMobileOpen(!mobileOpen);
    }
  }

  const drawer = (
    <div style={{ height: "100%", overflow: 'auto' }} className='scroll'>
      <div className={classes.drawerHeader}>
        <IconButton
          className={classes.topActionLight}
          color="inherit"
          aria-label="cerrar menu"
          onClick={handleDrawerToggle}
        >
          <Icon>chevron_left</Icon>
        </IconButton>
        <img src={logo_cuc_front} alt="Logo CUC" className={classes.logoVerticalTop} />
      </div>
      <List>
        {menuPrincipal(modulo.ruta, actividades, datoBuscar)}
      </List>
      <Divider />
      <List>
        {menuSecundario(mostrarModalCerrar)}
      </List>
    </div>
  );

  // Regex: uno global con grupo de captura para partir el texto por correos,
  const EMAIL_SPLIT = /([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})/g;
  const EMAIL_TEST = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

  const abrirChatTeams = (correo, e) => {
    e.preventDefault();
    e.stopPropagation();
    window.open(`https://teams.microsoft.com/l/chat/0/0?users=${correo}`, '_blank', 'noopener');
  };

  // Convierte los correos que vengan en la descripción en enlaces al chat de Teams.
  const renderDescripcion = (texto) => {
    if (!texto) return texto;
    return texto.split(EMAIL_SPLIT).map((parte, i) =>
      EMAIL_TEST.test(parte) ? (
        <Link
          key={i}
          component="span"
          role="button"
          underline="always"
          className={classes.notiCorreo}
          onClick={(e) => abrirChatTeams(parte, e)}
        >
          {parte}
        </Link>
      ) : (
        parte
      )
    );
  };

  const cardNoti = (imagen, nombre, descripcion, tieneEnlace) => (
    <Card className={classes.notiCard} elevation={0}>
      {imagen &&
        <img className={classes.notiImg} src={imagen} alt="Imagen notificación" />
      }
      <div className={classes.notiBody}>
        <span className={classes.notiTag}>
          <Icon style={{ fontSize: 18 }}>notifications</Icon> Importante
        </span>
        <Typography align='left' gutterBottom variant="h5" component="h2" className={classes.notiTitulo}>
          {nombre}
        </Typography>
        <Typography align='left' variant="body1" component="p" className={classes.notiDescripcion}>
          {renderDescripcion(descripcion)}
        </Typography>
        {tieneEnlace &&
          <span className={classes.notiVerMas}>
            Ver más <OpenInNewIcon style={{ fontSize: 16 }} />
          </span>
        }
      </div>
    </Card>
  )

  const cardDisentimiento = ({ nombre, descripcion, archivo, valorc }) => (
    <Card className={classes.disentimientoCard}>
      <CardContent className={classes.disentimientoContent}>
        <CardMedia
          component="img"
          alt="Formato de disentimiento"
          image={api + archivo}
          title="Formato de disentimiento"
          className={classes.disentimientoImagen}
        />
        <div className={classes.disentimientoTexto}>
          <Typography className={classes.disentimientoEtiqueta} component="span">
            Acción pendiente
          </Typography>
          <Typography className={classes.disentimientoTitulo} variant="h5" component="h2">
            {nombre}
          </Typography>
          <Typography className={classes.disentimientoDescripcion} variant="body2" color="textSecondary" component="p">
            {descripcion}
          </Typography>
          {valorc && valorc !== 'null' && (
            <Button
              component="span"
              variant="contained"
              className={classes.disentimientoBoton}
              endIcon={<OpenInNewIcon fontSize="small" />}
            >
              Diligenciar formato
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  )

  const renderNotificacion = (notificacion) => {
    const { codigo, nombre, descripcion, valorc, archivo } = notificacion;
    const esAvisoDisentimiento = codigo === COD_AVISO_DISENTIMIENTO;
    const tieneEnlace = valorc && valorc !== 'null';
    const contenido = esAvisoDisentimiento
      ? cardDisentimiento(notificacion)
      : cardNoti(archivo ? api + archivo : null, nombre, descripcion, tieneEnlace);

    if (!tieneEnlace) return contenido;

    const esRutaInterna = esAvisoDisentimiento && valorc.startsWith('/');
    const irAlFormato = (e) => {
      e.preventDefault();
      mostrarModalNotificaciones(false);
      if (location.pathname === valorc.split('?')[0]) window.location.assign(valorc);
      else history.push(valorc);
    };

    return (
      <Link
        href={valorc}
        target={esRutaInterna ? undefined : "_blank"}
        onClick={esRutaInterna ? irAlFormato : undefined}
        underline="none"
        className={`pointer ${esAvisoDisentimiento ? classes.disentimientoLink : classes.linkCard}`}
      >
        {contenido}
      </Link>
    );
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        elevation={0}
        className={`${classes.appBar} ${scrolled ? classes.appBarScrolled : ''} ${desktopOpen && !isEncuesta ? classes.appBarShift : ''}`}
      >
        <Toolbar >
          {/* Cuando el panel de escritorio esta abierto, la flecha y el logo
              viven dentro del encabezado del propio panel (ver `drawer` mas
              abajo) para no duplicarlos aqui. */}
          {!isEncuesta && !(isDesktop && desktopOpen) && (
            <IconButton
              className={`${classes.menuButton} ${classes.topActionLight}`}
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
            >
              <Icon>menu</Icon>
            </IconButton>
          )}
          {!(isDesktop && desktopOpen) && (
            <img src={logo_cuc_front} alt="Logo CUC" className={classes.logoVerticalTop} />
          )}
          <Typography variant="h6" className={classes.title}>
            {`${modulo.nombre}`}
          </Typography>
          <Tooltip title="Vídeos" aria-label="add">
            <IconButton color="inherit" className={classes.topActionLight} onClick={() => mostrarModalVideos(true)}>
              <Badge badgeContent={0} color="secondary">
                <Icon>video_library</Icon>
              </Badge>
            </IconButton>
          </Tooltip>
          {/* <Tooltip title="Notificaciones" aria-label="add">
            <IconButton color="inherit" className={classes.color_amr}>
              <Badge badgeContent={0} color="secondary">
                <Icon>notifications</Icon>
              </Badge>
            </IconButton>
          </Tooltip>
          <Tooltip title="Mensajes" aria-label="add" className='tiembla'>
            <IconButton color="inherit" className={classes.color_amr} onClick={() => mostrarModalMensajes(true)}>
              <Badge badgeContent={mensajes ? mensajes.length : 0} color="secondary">
                <Icon>email</Icon>
              </Badge>
            </IconButton>
          </Tooltip> */}
          <Perfil perfiles={[]} usuario={usuario} cerrarSesion={mostrarModalCerrar} />
        </Toolbar>
      </AppBar>
      {!isEncuesta && (
        <Hidden smUp implementation="css">
          <Drawer
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true,
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
      )}
      {!isEncuesta && (
        <Hidden xsDown implementation="css">
          <Drawer
            className={classes.drawer}
            variant="persistent"
            anchor="left"
            open={desktopOpen}
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
      )}

      <main className={`${classes.content} ${desktopOpen && !isEncuesta ? classes.contentShift : ''}`}>
        <div className={classes.toolbar} />
        <div
          id="seccion-vista"
          className={`${isDesktop && desktopOpen ? 'sidebar-open' : ''} ${isInicio ? 'inicio-view' : ''}`.trim()}
        >
          {/* {RutasPrincipales(actividades)} */}
          {/* <Mensajes /> */}
          {
            modalVideos &&
            <Videos modalVideos={modalVideos} mostrarModalVideos={mostrarModalVideos} />
          }
          <RutasPrincipales actividades={actividades} />
          <Copyright />
        </div>
        <ConfirmarAccion mensaje1={`Se cerrará la sesión actual, `} ejecutarAccion={cerrarSesion} mostrarModalConfAccion={mostrarModalCerrar} modalConAccion={modalCerrar} dato={{ id: 0 }} titulo={'¿ Cerrar Sesión ?'} />
      </main>

      {notificationes && notificationes.length > 0 &&
        <Dialog open={modalNotificaciones} maxWidth="md" fullWidth={true} onClose={false} classes={{ paper: classes.notiDialogPaper }}>
          <AppBarModal titulo='¡ Notificaciones !' mostrarModal={mostrarModalNotificaciones} titulo_accion='' close_switch={false} />
          <DialogContent className='scroll text-center'>
            <Grid container direction={'column'} spacing={3} style={{ marginTop: 10, marginBottom: 10 }} alignItems="center">
              {notificationes.map((noti) => (
                <Grid item xs={12} sm={12} md={12} lg={12} key={noti.id}>
                  {/* El aviso de disentimiento trae su propia tarjeta, sin el Paper. */}
                  {noti.codigo === COD_AVISO_DISENTIMIENTO
                    ? renderNotificacion(noti)
                    : (
                      <Paper elevation={1} className={classes.notiPaper}>
                        {renderNotificacion(noti)}
                      </Paper>
                    )
                  }
                </Grid>
              ))}
            </Grid>
          </DialogContent>
          <DialogActions>
            <BtnForm texto="Aceptar" callback={() => guardarConfirmacion()} />
          </DialogActions>
        </Dialog>
      }

    </div>
  );
}

class Principal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      render: false,
      notificationes: [],
      correoV: '',
      identificacion: '',
      urlParams: '',
      codeVerifier: '',
      sessionState: ''
    }
  }
  async componentDidMount() {
    let { urlParams, sessionState, codeVerifier } = this.state;
    urlParams = new URLSearchParams(window.location.search);
    sessionState = urlParams.get('code');
    let IdTokenApp = urlParams.get('id');
    if (IdTokenApp) {
      await this.validarTokenTemporal(IdTokenApp)
    } else {
      codeVerifier = localStorage.getItem('code_verifier');
      if (sessionState) this.handleAuth(sessionState, codeVerifier);
      else this.isAuth();
    }
  }
  componentDidUpdate({ auth }, { notificationes, sessionState }) {
    let { notificationes: notificationesNew, sessionState: sessionStateNew } = this.state;
    let { auth: authNew, mostrarModalNotificaciones } = this.props;
    if (authNew !== auth) {
      this.isAuth();
    }
    if (notificationesNew.length != notificationes.length && notificationesNew.length != 0) {
      mostrarModalNotificaciones(true)
    }
  }

  changeState = (render) => {
    this.setState({
      render,
    })
  }

  onChange = ({ target }) => {// evento que escucha los cambios del formulario y asigna el valor al estado de la variable
    let { value, name } = target;
    this.setState({
      [name]: value
    })
  }

  handleAuth = async (sessionState, codeVerifier) => {
    try {
      if (sessionState) {
        const requestOptions = {
          method: 'POST',
          cache: 'no-cache',
          mode: 'cors',
          body: JSON.stringify({ sessionState: sessionState, code_verifier: codeVerifier }),
          headers: {
            'Content-Type': 'application/json'
          }
        };
        try {
          const response = await fetch(`${api}/api/v1.0/microsoft/token/validate`, requestOptions);
          if (!response.ok) {
            throw new Error(`Error al realizar la solicitud: ${response.statusText}`);
          }
          const resp = await response.json();
          if (resp.access) {
            localStorage.setItem('token', resp.access);
            getFotoMs().then(function (data) {
              if (data.estado) {
                localStorage.setItem('fotoMs', data.data.foto);
                window.location.href = '/';
              }
            });
          } else {
            console.error("Error: No se recibió el token en la respuesta del servidor.");
          }
        } catch (error) {
          console.error("Error al realizar la solicitud:", error);
        }
      }
    } catch (error) {
      console.error('Error al procesar la autenticación:', error);
    }
  }

  isAuth = async () => {
    let { actualizarAuth, actualizarDataUsuarioAuth, actualizarActividades, actualizarCargandoMenu } = this.props;
    actualizarCargandoMenu(true)
    let { estado, resp } = await validarUsuarioApp();
    if (estado === 200) {
      let actividades = await obtenerActividadesPerfil(resp.id);
      // let notificationes = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': 1 }, { 'llave': 'estado', 'valor': '1' }, { 'llave': 'valora', 'valor': 'si' }]);
      consulta(
        'api/v1.0/poll/GetNotifications',
        null,
        'get',
        (err, status, data) => {
          this.setState({ notificationes: status === 200 && !err ? data : [] })
        }
      )
      actualizarActividades(actividades);
      actualizarDataUsuarioAuth(resp);
      actualizarAuth(true);
    } else {
      actualizarAuth(false);
      this.setState({ notificationes: [] })
    }
    actualizarCargandoMenu(false)
    this.changeState(true);
  }

  cerrarSesion = async () => {
    let { mostrarModalCerrar } = this.props;
    mostrarModalCerrar(false);
    let resp = await CerrarApp();
    if (resp) {
      this.setState({ urlParams: '', codeVerifier: '', sessionState: '' });
      this.isAuth();
    }
  };

  guardarConfirmacion = async () => {
    let { mostrarModalNotificaciones, actualizarMensaje } = this.props
    let { notificationes } = this.state

    let obligatorias = notificationes.filter(x => x.valorf === 'obligatorio')
    if (obligatorias.length > 0) {
      actualizarMensaje({
        titulo: 'Debe responder las notificaciones obligatorias antes de continuar.',
        tipo: 'info',
        mostrar: true,
        tiempo: 6000
      });
      return;
    }

    let array_encuestas = notificationes.filter(x => x.valore != 'confirm_ms').map(x => x.id)
    consulta(`api/v1.0/poll/confirmar`, { 'encuestas': array_encuestas }, "post", (error, estado, resp) => {
      let titulo = 'Ha ocurrido un error, contacte con el administrador.', tipo = 'error';
      if (!error) {
        if (estado === 200) {
          tipo = 'success';
          titulo = resp.titulo;
          mostrarModalNotificaciones(false)
        } else {
          tipo = 'info';
          titulo = resp.titulo ? resp.titulo : mostrarError(resp);
        }
      }
      actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 });
    }
    )
  }

  validarTokenTemporal = async (id) => {
    const { actualizarAuth } = this.props;
    if (!id) return;

    consulta(`api/v1.0/auth/validar_token?id=${id}`, null, "get", (error, estado, resp) => {
      if (!error) {
        if (estado === 200 && resp.token) {
          localStorage.setItem('token', resp.token);
          actualizarAuth(true);
          getFotoMs().then(function (data) {
            if (data.estado) {
              localStorage.setItem('fotoMs', data.data.foto);
            }
          });
        }
      }
    }, false
    );
  }


  render() {
    let { modulo, auth, modalCerrar, mostrarModalCerrar, usuario, actividades, mensajes, mostrarModalMensajes, mostrarModalNotificaciones, modalNotificaciones, modalRegistrar, mostrarModalRegistrar, mostrarModalVideos, modalVideos } = this.props;
    let { render, notificationes, correoV, identificacion } = this.state;
    if (render) {
      if (auth) return (<Modulo mostrarModalMensajes={mostrarModalMensajes} mensajes={mensajes} changeProfile={this.changeProfile} modulo={modulo} cerrarSesion={this.cerrarSesion} modalCerrar={modalCerrar} mostrarModalCerrar={mostrarModalCerrar} usuario={usuario} actividades={actividades} mostrarModalNotificaciones={mostrarModalNotificaciones} modalNotificaciones={modalNotificaciones} notificationes={notificationes} guardarConfirmacion={this.guardarConfirmacion} mostrarModalVideos={mostrarModalVideos} modalVideos={modalVideos} />);
      else return (<RutasInicio modalRegistrar={modalRegistrar} mostrarModalRegistrar={mostrarModalRegistrar} correoV={correoV} identificacion={identificacion} onChange={this.onChange} />)
    } else return (<Cargando />)
  }
}

const mapStateToProps = state => {
  let { modulo, auth, modalCerrar, usuario, actividades, mensajes, modale, modalNotificaciones, modalRegistrar, modalVideos } = state.redGlobal;

  return {
    modulo,
    auth,
    modalCerrar,
    usuario,
    actividades,
    mensajes,
    modalNotificaciones,
    modalRegistrar,
    modalVideos
  }
};

const mapDispatchToProps = {
  actualizarAuth,
  actualizarDataUsuarioAuth,
  mostrarModalCerrar,
  actualizarActividades,
  actualizarMensaje,
  mostrarModalMensajes,
  actualizarCargandoMenu,
  mostrarModalNotificaciones,
  mostrarModalRegistrar,
  mostrarModalVideos
}

//Props del componente
Principal.propTypes = {
  //variables
  auth: PropTypes.bool.isRequired,
  modalCerrar: PropTypes.bool.isRequired,
  modulo: PropTypes.object.isRequired,
  usuario: PropTypes.object.isRequired,
  actualizarAuth: PropTypes.func.isRequired,
  actualizarDataUsuarioAuth: PropTypes.func.isRequired,
  mostrarModalCerrar: PropTypes.func.isRequired,
  actividades: PropTypes.array.isRequired,
  actualizarActividades: PropTypes.func.isRequired,
  actualizarMensaje: PropTypes.func.isRequired,
  mostrarModalMensajes: PropTypes.func.isRequired,
  mostrarModalVideos: PropTypes.func.isRequired,
}
//Props del componente
Modulo.propTypes = {
  //variables
  modulo: PropTypes.object.isRequired,
  modalCerrar: PropTypes.bool.isRequired,
  usuario: PropTypes.object.isRequired,
  mostrarModalCerrar: PropTypes.func.isRequired,
  cerrarSesion: PropTypes.func.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(Principal);
